import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=6482bb4d&scoped=true&"
import script from "./icon.js?vue&type=script&lang=js&"
export * from "./icon.js?vue&type=script&lang=js&"
import style0 from "./icon.scss?vue&type=style&index=0&id=6482bb4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6482bb4d",
  null
  
)

export default component.exports